import styles from './morebutton.scss'

export default class morebutton extends React.Component {
  render () {
    let classes = ['m-button']

    if (this.props.class) {
      classes = [this.props.class]
    }

    return (
      <a href={this.props.url} class={classes.join(' ')}>{this.props.value}</a>
    );
  }
}